import { useEffect, useState, useRef } from 'preact/hooks'
import { useAppContext } from '../contexts/AppContext'
import { EMAIL_REG_EXP, ON_ACTION_CARD_SAVE_EVENT } from '../constants/index'

function useEmailControl() {
  const { actionCardService, loggedInUserEmail } = useAppContext()
  const [isPolicyAccepted, setIsPolicyAccepted] = useState(!!loggedInUserEmail)
  const [webPlayEmail, setWebPlayEmail] = useState(null)
  const [isWebPlayEmailInputVisible, setIsWebPlayEmailInputVisible] = useState(true)
  const forceWebPlayEmailVisibility = useRef(false)

  useEffect(() => {
    syncWebPlayEmail()

    window.addEventListener(ON_ACTION_CARD_SAVE_EVENT, syncWebPlayEmail)
    return () => {
      window.removeEventListener(ON_ACTION_CARD_SAVE_EVENT, syncWebPlayEmail)
    }
  }, [actionCardService])

  function syncWebPlayEmail() {
    if (loggedInUserEmail && EMAIL_REG_EXP.test(loggedInUserEmail)) {
      setIsWebPlayEmailInputVisible(false)
      setWebPlayEmail(loggedInUserEmail)
      return
    }

    const emailNode = actionCardService.getEmailNode()

    if (!emailNode) {
      // if email node isn't found (more likely isn't addedd)
      // we shouldn't set webPlay email to undefined
      // in other cases - value of the email in action card has to be synchronized with the email-input in the popup
      return
    }

    const email = emailNode.getValue()
    setWebPlayEmail(email)
    setIsWebPlayEmailInputVisible(!EMAIL_REG_EXP.test(email) || forceWebPlayEmailVisibility.current)
  }

  return {
    webPlayEmail,
    setWebPlayEmail: email => {
      forceWebPlayEmailVisibility.current = true
      setWebPlayEmail(email)
      if (!email || EMAIL_REG_EXP.test(email)) {
        actionCardService.getEmailNode()?.setValue(email)
      }
    },
    isPolicyAccepted,
    setIsPolicyAccepted,
    isWebPlayEmailInputVisible,
    isWebPlayEmailValid: webPlayEmail && !!EMAIL_REG_EXP.test(webPlayEmail),
  }
}

export default useEmailControl
